import { useLicensePlateTypes } from '../queries';
import { useFleet } from './useFleet';

export const useRequiresPlateType = () => {
  const fleet = useFleet();

  const fleetRequiresPlateType = Boolean(
    fleet.config?.feature_config?.is_license_plate_type_required,
  );

  return fleetRequiresPlateType;
};

// Undefined while the query is loading, and for a fleet whose authorities own no plate types.
// There is no safe fallback id: types are scoped per authority, so an id belonging to another
// authority is rejected by the API. Callers must handle undefined rather than send a guess.
export const useDefaultPlateTypeId = (): number | undefined => {
  const enabled = useRequiresPlateType();
  const { data: licensePlateTypes } = useLicensePlateTypes(enabled);

  return licensePlateTypes?.[0]?.license_plate_type_id;
};
